import { TRACKER_TYPE } from '../enums/tracker.enum';
import { TrackingService } from '../tracking.service';

/**
 * Creates an account tracking function that doesn't depend on inject()
 * 
 * This factory creates a function that can be used outside injection context
 * since it already receives the TrackingService instance as parameter.
 * 
 * @param trackingService TrackingService instance
 * @returns A function that can be used to track account events
 * 
 * @example
 * // In a service constructor or field initialization:
 * private readonly trackAccount = createAccountTracker(this.trackingService);
 * 
 * // Then use it anywhere in your class:
 * this.trackAccount('Account created', { id: '123' });
 */
export function createAccountTracker(trackingService: TrackingService) {
  /**
   * Records account-related activity for tracking purposes.
   *
   * @param message - Description of the account activity
   * @param customData - Optional additional data to include in the tracking
   */
  return function trackAccount(message: string, customData?: unknown): void {
    trackingService.addTrack({
      type: TRACKER_TYPE.account,
      body: {
        message,
        customData,
      },
    });
  };
} 